import { SystemDropdownCategory, SystemDropdownParameter } from "@/api";
import { useSystemDropdownOptions } from "@/common/hooks/useSystemDropdownOptions";

/**
 * The appointment purposes (Termin-Zwecke) that can be asked for in return. A purpose switched off for the
 * exchange can never be offered, so asking for one would leave the request unfulfillable; the backend
 * rejects it as well.
 */
export function useRequestablePurposes() {
  const purposes = useSystemDropdownOptions(SystemDropdownCategory.AppointmentPurpose);

  const options = purposes.options.filter((option) =>
    purposes.booleanParameterOf(option.key, SystemDropdownParameter.AvailableInExchange)
  );

  return { options, isLoading: purposes.isLoading };
}
